import styled, { css } from 'styled-components';

export const StyledInput = styled.input<{
  isUnionControlGroup?: boolean;
  shaded?: boolean;
  isValid?: boolean;
  hasWarning?: boolean;
  hasCaution?: boolean;
  isTouched?: boolean;
}>`
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  border-style: solid;
  border-width: 1px;
  font-size: ${({ theme }) => theme.fontSize.base}px;
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.white};
  appearance: none;
  outline: 0;
  padding: 9px 9px 10px 9px;
  border-radius: ${({ theme }) => theme?.Input?.borderRadius};
  font-family: ${({ theme }) => theme?.fontFamily?.regular};
  line-height: 1.29;

  ${({ isUnionControlGroup }) => isUnionControlGroup && css`
    border-radius: 0;
  `}

  ${({ shaded }) => shaded && css`
    border-color: ${({ theme }) => theme?.Input?.borderColor || 'transparent'};
    border-bottom-color: ${({ theme }) => theme?.Input?.bottomBorderColor || theme?.Input?.borderColor || theme.colors.darkerGray};
  `}

  ${({ shaded }) => !shaded && css`
    border-color: ${({ theme }) => theme?.Input?.borderColor || theme.colors.mediumGray};
    border-bottom-color: ${({ theme }) => theme?.Input?.bottomBorderColor || theme?.Input?.borderColor || theme.colors.darkGray};
  `}

  ${({ readOnly }) => !readOnly && css<{
    value?: string | number | readonly string[];
    isValid?: boolean;
    isTouched?: boolean;
    hasWarning?: boolean;
    hasCaution?: boolean;
  }>`
    &:not(:disabled) {
      ${({ theme, hasCaution, isTouched }) => hasCaution && isTouched && css`
        border: ${theme?.Input?.cautionBorder};
        padding: ${theme?.Input?.cautionPadding};
      `}

      ${({ theme, hasWarning, isTouched }) => hasWarning && isTouched && css`
        border: ${theme?.Input?.warningBorder};
        padding: ${theme?.Input?.warningPadding};
      `}

      ${({ theme, isValid, isTouched }) => (!isValid && isTouched) && css`
        border: ${theme?.Input?.invalidBorder};
        padding: ${theme?.Input?.invalidPadding};
      `}

      &:hover {
        ${({ theme, hasCaution, isTouched }) => (hasCaution && isTouched) && css`
          border-color: ${theme?.Input?.cautionHoverBorderColor || theme?.Input?.cautionBorderColor || theme.colors.caution};
        `}

        ${({ theme, hasWarning, isTouched }) => (hasWarning && isTouched) && css`
          border-color: ${theme?.Input?.warningHoverBorderColor || theme?.Input?.warningBorderColor || theme.colors.warning};
        `}

        ${({ theme, isValid, isTouched }) => (!isValid && isTouched) && css`
          border-color: ${theme?.Input?.invalidHoverBorderColor || theme?.Input?.invalidBorderColor || theme.colors.orange1};
        `}

        ${({ theme, isValid, hasWarning, hasCaution, isTouched, value }) => ((isValid && !hasWarning && !hasCaution) || !isTouched) && css<{
          isValid?: boolean;
          isTouched?: boolean;
        }>`
          border-color: ${theme?.Input?.hoverBorderColor || theme.colors.focus};
          ${(value || value === 0) && isValid && css`
            border-bottom-color: ${theme?.Input?.validBottomBorderColor || theme.colors.light}
          `};
        `}
      }

      &:focus {
        outline: none;
        box-shadow: ${({ theme }) => `${theme.colors.focus} 0 0 3px 1px`};
        border-color: ${({ theme }) => theme.colors.focus};
        border: ${({ theme }) => theme?.Input?.focusBorder};
        padding: ${({ theme }) => theme?.Input?.focusPadding};
      }

      &:focus:not(:focus-visible) {
        box-shadow: none;
      }

      ${({ value, isValid }) => (value || value === 0) && isValid && css`
        border-bottom-color: ${({ theme }) => theme?.Input?.validBottomBorderColor};
      `};
    }

    [disabled], :disabled {
      background: ${({ theme }) => theme.colors.gray1};
      font-style: ${({ theme }) => theme?.Input?.disabledFontStyle};
      color: ${({ theme }) => theme?.Input?.disabledColor};
    }
  `}

  ${({ readOnly }) => readOnly && css`
    background: ${({ theme }) => theme.colors.gray1};
  `}
`;
